import { render, staticRenderFns } from "./FigureMoldLinkage.vue?vue&type=template&id=226f0ee6&scoped=true&"
import script from "./FigureMoldLinkage.vue?vue&type=script&lang=js&"
export * from "./FigureMoldLinkage.vue?vue&type=script&lang=js&"
import style0 from "./FigureMoldLinkage.vue?vue&type=style&index=0&id=226f0ee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226f0ee6",
  null
  
)

export default component.exports